/** @jsx builderX.jsx */
import { builderX, Sprite, Image } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='background'>
    <Sprite name='base'>
        <Sprite name='landscape'>
            <Sprite name='bgContainer'>
                <Image name='bg' src='bg'/>
                <Sprite name='animationContainer'/>
            </Sprite>
            <Image position={[380, 200]} name='frame' src='reelframe'/>
        </Sprite>
        <Sprite name='portrait'>
            <Sprite name='bgContainer'>
                <Image name='bg' src='bg_pm'/>
                <Sprite name='animationContainer'/>
            </Sprite>
            <Image position={[0, 900]} scale={[0.7, 0.7]} name='frame' src='reelframe'/>
        </Sprite>
    </Sprite>
    <Sprite name='freespins'>
        <Sprite name='landscape'>
            <Sprite name='bgContainer'>
                <Image name='bg' src='bg_fg'/>
                <Sprite name='animationContainer'/>
            </Sprite>
            <Image position={[380, 200]} name='frame' src='reelframe'/>
        </Sprite>
        <Sprite name='portrait'>
            <Sprite name='bgContainer'>
                <Image name='bg' src='bg_fg_pm'/>
                <Sprite name='animationContainer'/>
            </Sprite>
            <Image position={[0, 900]} scale={[0.7, 0.7]} name='frame' src='reelframe'/>
        </Sprite>
    </Sprite>
</Sprite>;
